import React from 'react';

import { BLDiv } from '../../AppStyles/GenericStyledComponents';

import TopPicText from './TopPicText';
import CommunicationDoubleDivide from './CommunicationDoubleDivide';
import CommentForm from './CommentForm';
import SimpleTextBar from '../Generic/SimpleTextBar';

class ContactUsSection extends React.Component {
  state = {
    formDisplayed: false,
    thanksBarDisplayed: false,
    errorBarDisplayed: false
  }

  handleFormSubmit = event => {
    console.log("here")
    event.preventDefault()
    // const emailjs = require('https://cdn.emailjs.com/dist/email.min.js');
    window.emailjs.send("default_service","contactus",
      {from_name: this.state.firstName+" "+this.state.lastName,
      message_html: this.state.message, reply_to: this.state.email})
      .then(response => {
          console.log("SUCCESS. status=%d, text=%s", response.status, response.text);
          this.setState({thanksBarDisplayed: true});
      }, err => {
          console.log("FAILED. error=", err);
          this.setState({errorBarDisplayed: true});
      });
     
    // axios.post("api/contacts/create", this.state)
    //   .then( res =>
    //     res.status === 200 ? this.setState({thanksBarDisplayed: true}) : this.setState({errorBarDisplayed: true}) )
    //   .then( res => this.setState({name: '', email: '', message: ''}) )
    //   .catch( res => {this.setState({errorBarDisplayed: true}); console.log(res)})
  }
  
  handleFormChange = (e) => {
    const { id , value } = e.target;
    this.setState({ [id]: value });
  }
  
    render() {
      var ThisView = null;

      const CommentFormView = (
        <CommentForm
          commentDisplay={() => this.setState({formDisplayed: false, thanksBarDisplayed: false, errorBarDisplayed: false})}
          commentSubmitFunction={this.handleFormSubmit}
          handleChange={this.handleFormChange}
        />
      )

      this.state.errorBarDisplayed || this.state.thanksBarDisplayed ? setTimeout(() => { this.setState({formDisplayed: false, thanksBarDisplayed: false, errorBarDisplayed: false}) }, 3000) : null

      if (this.state.errorBarDisplayed) {
        ThisView = (
          <BLDiv padding={'0'}>
            <SimpleTextBar
              textBig="Note send failed — please try again"
              />
              {CommentFormView}
          </BLDiv>
        )
      } else if (this.state.thanksBarDisplayed) {
        ThisView = (
          <BLDiv padding={'0'}>
          <SimpleTextBar
            textBig="Thanks for the note — we'll get back to you ASAP"
            />
            <SimpleTextBar
            />
          </BLDiv>
        )
      } else if (this.state.formDisplayed) {
        ThisView = CommentFormView;
      } else {
        ThisView = (
          <CommunicationDoubleDivide
            commentDisplay={() => this.setState({formDisplayed: true})}
          />
        )
      }
      
      return (
        <div>
          <TopPicText />
          {ThisView}
        </div>
      )  }
}

export default ContactUsSection;


// WEBPACK FOOTER //
// ./src/interface/components/Contact Us/ContactUsSection.js